import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=54a4abea&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=ts"
export * from "./noticeDetail.vue?vue&type=script&lang=ts"
import style0 from "./noticeDetail.vue?vue&type=style&index=0&id=54a4abea&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4abea",
  null
  
)

export default component.exports